import React, { useEffect } from "react";
import PageShell from "../components/PageShell";
import { Sparkles, ShieldCheck, BookOpen } from "lucide-react";

const About = () => {
  useEffect(() => {
    document.title = "About — topastrologerinindia.com";
  }, []);
  return (
    <PageShell
      title="About topastrologerinindia.com"
      subtitle="India's most trusted independent ranking of online astrologers."
    >
      <p className="text-[15px] leading-relaxed text-slate-700">
        topastrologerinindia.com is an independent editorial platform that ranks the top
        astrologers in India for online consultation. We were founded in 2025 to help seekers
        cut through noise and connect with genuinely experienced astrologers — across Vedic, KP,
        Nadi, Tarot, Numerology and Vastu disciplines.
      </p>

      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <div className="border border-slate-200 rounded-lg p-5">
          <Sparkles className="w-5 h-5 text-[#16a3a8]" />
          <h3 className="text-base font-bold text-[#0b1e3f] mt-2">Editorial</h3>
          <p className="text-sm text-slate-600 mt-1">
            250+ hours of research; rankings updated regularly.
          </p>
        </div>
        <div className="border border-slate-200 rounded-lg p-5">
          <ShieldCheck className="w-5 h-5 text-[#16a3a8]" />
          <h3 className="text-base font-bold text-[#0b1e3f] mt-2">Independent</h3>
          <p className="text-sm text-slate-600 mt-1">
            We do not take commission on consultations. Rankings are opinion-based.
          </p>
        </div>
        <div className="border border-slate-200 rounded-lg p-5">
          <BookOpen className="w-5 h-5 text-[#16a3a8]" />
          <h3 className="text-base font-bold text-[#0b1e3f] mt-2">Practical</h3>
          <p className="text-sm text-slate-600 mt-1">
            We surface astrologers who give clear, actionable guidance.
          </p>
        </div>
      </div>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-10 mb-2">How we rank</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        Every astrologer on our list is evaluated on five factors: years of practice, depth of
        expertise across classical systems (Vedic, KP, Nadi), verified consultation count,
        accessibility (response time, languages), and client feedback. Top-ranked astrologers are
        those who score consistently high across all five.
      </p>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">Our editorial promise</h2>
      <ul className="list-disc pl-6 mt-2 space-y-1 text-[15px] text-slate-700">
        <li>No paid placements. Rank order is editorial opinion.</li>
        <li>No commission on consultations. The chat is directly between you and the astrologer.</li>
        <li>Astrology guidance is for entertainment and personal reflection. It does not replace medical, legal, or financial advice.</li>
      </ul>

      <h2 className="text-xl font-bold text-[#0b1e3f] mt-8 mb-2">Contact</h2>
      <p className="text-[15px] leading-relaxed text-slate-700">
        Editorial enquiries: <a href="mailto:sachinsharma6886@gmail.com" className="text-[#16a3a8] font-semibold">sachinsharma6886@gmail.com</a>
      </p>
    </PageShell>
  );
};

export default About;
